import React from "react";
import { useQuickSightLambda  } from "@/hooks/useLambdaReports";

const QuickSightAwsLambdaDashboard = () => {
  const { embedUrl } = useQuickSightLambda ();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightAwsLambdaDashboard;
